import React, { useEffect, useState } from "react"
import { Clock, CreditCard as Edit, Plus, Printer } from "lucide-react"
import Button from "../common/Button.jsx"
import OrderStatusBadge from "./OrderStatusBadge.jsx"

/**
 * @param {{
 *   status: string,
 *   showCreateSoButton?: boolean,
 *   onEditOrder?: () => void,
 *   onNotImplemented?: () => void,
 *   onViewPrintOrder?: () => void,
 *   onPrintBoxLabels?: () => void,
 *   onTimeline?: () => void,
 *   order?: any,
 *   renderActions?: (() => React.ReactNode) | null,
 * }} props
 */
export default function OrderStatus({
    status,
    showCreateSoButton = true,
    onEditOrder = () => {},
    onNotImplemented = () => {},
    onViewPrintOrder = () => {},
    onPrintBoxLabels = () => {},
    onTimeline = () => {},
    order = null,
    renderActions = null,
}) {
    const [isLgUp, setIsLgUp] = useState(
        typeof window !== "undefined" ? window.innerWidth >= 992 : true
    )

    useEffect(() => {
        function onResize() {
            setIsLgUp(window.innerWidth >= 992)
        }

        window.addEventListener("resize", onResize)
        return () => window.removeEventListener("resize", onResize)
    }, [])

    return (
        <div
            className={`${
                isLgUp ? "position-sticky top-0" : ""
            } card rounded shadow-sm border mb-4 p-4`}
            style={{ zIndex: 10 }}
        >
            <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                <div className="d-flex align-items-center">
                    <span className="fs-6 fw-semibold text-secondary me-3">Status:</span>
                    <OrderStatusBadge status={status} />
                </div>

                <div className="d-flex flex-wrap gap-2">
                    {typeof renderActions === "function" ? renderActions() : null}
                    <Button
                        variant="outline"
                        size="sm"
                        icon={<span><Edit size={16} /></span>}
                        onClick={onEditOrder}
                    >
                        Edit Order
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        icon={<span><Printer size={16} /></span>}
                        onClick={onViewPrintOrder}
                    >
                        View / Print Order
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        icon={<span><Printer size={16} /></span>}
                        onClick={onPrintBoxLabels}
                    >
                        Print Box Labels
                    </Button>
                    {showCreateSoButton ? (
                        <Button
                            variant="outline"
                            size="sm"
                            icon={<span><Plus size={16} /></span>}
                            className="v2-not-implemented-btn"
                            onClick={() => onNotImplemented?.()}
                            title="Not implemented yet"
                        >
                            Create SO
                        </Button>
                    ) : null}
                    <Button
                        variant="outline"
                        size="sm"
                        icon={<span><Clock size={16} /></span>}
                        onClick={onTimeline}
                    >
                        Timeline
                    </Button>
                </div>
            </div>
        </div>
    )
}
